import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Icon, IconName } from "@formant/ui/component/common/Icon";
import { animate } from "@formant/ui/utils/animate";

import { track } from "../../analytics";
import * as styles from "./CopyCode.scss";
import { copyToClipboard } from "./copyToClipboard";
import { StandardButton } from "./StandardButton";

export interface ICopyCodeProps extends ITestableComponentProps {
    value: string;
    icon?: IconName;
    singleLine?: boolean;
    className?: string;
}

@observer
export class CopyCode extends Component<ICopyCodeProps> {
    @observable
    private copied: boolean = false;

    public render() {
        const { value, icon, singleLine, className } = this.props;
        const { onCopy } = this;

        return (
            <div
                className={classnames(
                    styles["copy-code"],
                    this.copied && styles.copied,
                    singleLine && styles["single-line"],
                    className,
                )}
            >
                {icon && <Icon name={icon} />}
                <div className={styles.value} data-testid="copy-data-string">
                    {value}
                </div>
                <StandardButton
                    lighter={true}
                    className={styles.copy}
                    onClicked={onCopy}
                    data-testid={this.props["data-testid"]}
                >
                    Copy
                </StandardButton>
            </div>
        );
    }

    private onCopy = async () => {
        if (this.props.value.includes("install-agent.sh")) {
            track("Installation script copied");
        }
        copyToClipboard(this.props.value);
        this.copied = true;
        await animate();
        this.copied = false;
    };
}
